import { ContainerModule } from 'inversify';
import { StoreApi, UseBoundStore } from 'zustand';

import { IWorkspaceStore, useWorkspaceStore } from '@desygner/ui-data-access-workspace';

import type { IConfigStore } from './config.store';
import { useConfigStore } from './config.store';
import { IUserStore, useUserStore } from './user.store';
import { IViewerStore, useViewerStore } from './viewer/viewer.store';

export const TYPES = {
  Config: Symbol('ConfigStore'),
  Viewer: Symbol('ViewerStore'),
  User: Symbol('UserStore'),
  Workspace: Symbol('WorkspaceStore'),
};

export type IConfigStoreInjector = UseBoundStore<StoreApi<IConfigStore>>;
export type IViewerStoreInjector = UseBoundStore<StoreApi<IViewerStore>>;
export type IUserStoreInjector = UseBoundStore<StoreApi<IUserStore>>;
export type IWorkspaceStoreInjector = UseBoundStore<StoreApi<IWorkspaceStore>>;

const storeContainer = new ContainerModule((bind) => {
  bind<IConfigStoreInjector>(TYPES.Config).toConstantValue(useConfigStore);
  bind<IViewerStoreInjector>(TYPES.Viewer).toConstantValue(useViewerStore);
  bind<IUserStoreInjector>(TYPES.User).toConstantValue(useUserStore);
  bind<IWorkspaceStoreInjector>(TYPES.Workspace).toConstantValue(useWorkspaceStore);
});

export type { IConfigStore, IViewerStore };

export { storeContainer };

export { useConfigStore, useViewerStore, useUserStore };
